import {mapState} from 'vuex';
export default {
    data(){
        return {
            keyWord:'', // 搜索关键词
            page:1,  //当前页码
            pageSize: 10,   //每页显示条数
            totalCount:0,    //总条数
            tableData: [],   //表格数据
            loading:false,   //表格加载
            uuid:'',
            areaCode: '',
            formInline: {},
        };
    },
    computed:{
        ...mapState(['isReset']),
    },
    watch:{

    },
    activated(){
        // console.log(this.isReset)
        if(this.isReset) {
            this.init();
        }
        this.getTableData();
        // console.log(this.$route.name+'----activated')
    },
    mounted(){
        // console.log(this.$route.name+'----mounted')
        if(!this.$route.meta.keepAlive){
            this.getTableData();
        }
    },
    methods: {
        getCookie(key) {
            let str = document.cookie
            str = str.split('; ')
            if (str.length > 0) {
              const a = str.find((it) => it.indexOf(key) > -1)
              if (a) {
                return a.split('=')[1]
              } else {
                return ''
              }
            } else {
              return ''
            }
          },
        init(){
            this.page=1;
            this.pageSize=10;
            this.keyWord='';
            this.formInline.areaCode = localStorage.getItem('tenantAreaCode');
            if(this.$refs['formInline']){
                this.$refs['formInline'].resetFields();
            }
            Object.assign(this.formInline, this.$route.query)
        },
        /*高级查询*/
        handleQuery() {
            this.page=1;
            this.getTableData();
        },
        /*搜索查询*/
        handleSearch() {
            this.keyWord=this.keyWord.replace(/'/g,'');
            this.page = 1;
            this.getTableData();
        },
        /*获取表格数据*/
        getTableData(){ },
        /*新页数*/
        changePage(value) {
            this.page=value;
            this.getTableData();
        },
        /*每页的条数*/
        pageSizeChange(value){
            this.pageSize=value;
            this.page=1;
            this.getTableData();
        },

    }
};
